import React from 'react';
import { Card } from 'react-bootstrap';

const ModuleContainer = (props) => {
    return (
        <Card className={"module-container"} style={props.style}>
            {props.children}
        </Card>
    );
};

export default ModuleContainer;